"use client";

import { useEffect, type RefObject } from "react";
import { useUiActions } from "@/features/lomdaEditorV2/store";

/**
 * Clears the canvas selection when the user clicks inside `containerRef`
 * but outside its first child (the scene element).
 */
export function useDeselectOnOutsideClick(
    containerRef: RefObject<HTMLElement>
) {
    const { clearSelection } = useUiActions();

    useEffect(() => {
        const onClick = (e: MouseEvent) => {
            const container = containerRef.current;
            if (!container || !(e.target instanceof Node)) return;
            const sceneEl = container.firstElementChild;
            if (
                container.contains(e.target) &&
                (!sceneEl || !sceneEl.contains(e.target))
            ) {
                clearSelection();
            }
        };
        document.addEventListener("click", onClick);
        return () => document.removeEventListener("click", onClick);
    }, [containerRef, clearSelection]);
}
